
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loans/[coin]",
      function () {
        return require("private-next-pages/loans/[coin]/index.p.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loans/[coin]"])
      });
    }
  